//Axios config file
import axios from "axios";

const api = axios.create({
  baseURL: process.env.VUE_APP_FUNCTION_HOST,
  timeout: 3000,
});

// export const newPromise = new Promise((resolve, reject) => {});
export const getCampaignByIdPromise = function (campaignId) {
  return new Promise((resolve, reject) => {
    api
      .get("/campaign", {
        params: {
          campaignId: campaignId,
        },
      })
      .then(function (response) {
        resolve(response.data.campaign);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

export const traffic = function(trafficId = null, traffic = {}) {
  return new Promise((resolve, reject) => {
    api.post("/traffic", {
      trafficId: trafficId,
      traffic: traffic
    })
    .then((response) => {
      resolve(response.data)
    })
    .catch((error) => {
      reject(error)
    })
  })
};

export const getCampaignById = async function (campaignId) {
  let campaign;
  await api
    .get("/campaign", {
      params: {
        campaignId: campaignId,
      },
    })
    .then(function (response) {
      campaign = response.data.campaign;
    })
    .catch(function (error) {
      campaign = error;
    });
  return campaign;
};

export const getCampaignByName = async function (campaignName) {
  let campaigns;
  await api
    .get("/campaign", {
      params: {
        campaignName: campaignName,
      },
    })
    .then(function (response) {
      campaigns = response.data;
    })
    .catch(function (error) {
      campaigns = error;
    });
  return campaigns;
};

export const saveCampaign = async function (campaign) {
  let id;
  await api
    .post("/campaign", { campaign: campaign })
    .then(function (response) {
      id = response.data.campaign._id;
    })
    .catch(function (/*error*/) {
      id = "";
    });
  return id;
};

export const getEnums = async function () {
  let enums;
  await api
    .get("/enums", {})
    .then(function (response) {
      enums = response.data;
    })
    .catch(function (error) {
      enums = error;
    });
  const { ContentTypeEnum, CampaignEnum } = enums;
  return {
    contentTypeEnum: ContentTypeEnum,
    campaignEnum: CampaignEnum,
  };
};
